import actionTypes from '../actionTypes'

const updateWorkspaces = workspaces => {
  return {
    type: actionTypes.SET_WORKSPACES,
    payload: workspaces,
  }
}

const updateSelectedWorkspace = workspace => {
  return {
    type: actionTypes.SET_SELECTED_WORKSPACE,
    payload: workspace,
  }
}

const updateWsRole = role => {
  return {
    type: actionTypes.SET_WS_ROLE,
    payload: role,
  }
}

const updateProgressData = data => {
  return {
    type: actionTypes.SET_PROGRESS_DATA,
    payload: data,
  }
}

const updateProgressDrawers = data => {
  return {
    type: actionTypes.SET_PROGRESS_DRAWERS,
    payload: data,
  }
}

export default {
  updateWorkspaces,
  updateSelectedWorkspace,
  updateWsRole,
  updateProgressData,
  updateProgressDrawers
}